export const permission = {
  User: ["/home/user", "/streamEvent", "/makePayment", "/changeEmail", "/changePassword"],
  Corporate: ["/home/user", "/streamEvent", "/makePayment", "/changeEmail", "/changePassword"],
  Actor: ["/home/actor", "/streamEvent", "/changeEmail", "/changePassword", "/howToGoLive"],
  admin: [""],
};

// NOTE: Change route permissions according to role if required
